import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartDataTile from '../dashboard/MyChartDataTile';
import * as types from "../../constants/actionTypes";
import useQualtrics from "./hooks/useQualtrics";
import useShowQTXSurvey from "./hooks/useShowQTXSurvey";

const Procedure = (props) => {
    console.info(`Procedure props`, props);
    const { history, touch, match } = props;
    const location = window.store.getState().locations;
    const [showQTXSurvey, setShowQTXSurvey] = useState(false);
    const [childFrameData, setChildFrameData] = useState({});
    const bswMatch = ".card.helptip.success";
    const observe = "div#content";
    const enableSurvey = window.serverData.data.enableQualtricsSurveyDirectScheduling;
    const events = [{ elements: ".card", eventName: "click", message: "childFrameChanged" }];

    const rfvId = match && match.params && match.params.rfvId ? match.params.rfvId  : null;
    const workflow = match && match.params && match.params.workflow ? match.params.workflow : "Procedure";        
    const selRfvId = rfvId;

    const mode = `scheduling&workflow=${workflow}${rfvId ? `&rfvId=${rfvId}` : ""}${selRfvId ? `&selRfvId=${selRfvId}` : ""}`;
    useEffect(() => {
        touch(false);
        logUI("MBHWeb.UI.Procedure.ComponentDidMount", new Date(), Tools.getURLPath(), { "mode": mode });
    }, []);
    useEffect(() => {
        const shouldShowQTXSurvey = useShowQTXSurvey(enableSurvey, childFrameData, bswMatch);
        if (shouldShowQTXSurvey) {
            setShowQTXSurvey(true);
            //touch(false);
            logUI("MBHWeb.UI.Procedure.Completed", new Date(), Tools.getURLPath(), { "mode": mode });
        }


        return () => { console.info(`Procedure childFrameData some stupid clean up that does not clean up anything.`); };
    }, [childFrameData]);

    useQualtrics(showQTXSurvey);


    return (
        <MyChartDataTile mode={mode}
            onMessage={event => { doEventMatch(event, history, locCityAndState, touch); }} bswQtxID="bsw_qtx_video_schedule" events={events} bswMatch={bswMatch} observe={observe} onObserved={(data) => { setChildFrameData(data); }} showQTXSurvey={showQTXSurvey}/>);
   
}

const doEventMatch = (event, history, locCityAndState, touch) => {
    if (event.data.bswElement) {
        const bswElement = event.data.bswElement;
        if (event.data.evt.elements === ".card" && event.data.evt.eventName === "click") {
            console.info('Procedure doEventMatch card CLICK', event);
            touch(true);
        }
    }
}



const mapStateToProps = (state) => {
    console.info(`Procedure mapStateToProps state`, state);
    return {
        touched: state.myChartDataTile.touched
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        touch: (isTouched) => dispatch({ type: types.MYCHART_DATA_TILE_TOUCHED, data: { touched: isTouched } })
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Procedure));